import React, { useState, useEffect  } from "react";
import { db } from "../firebase"; 
import { ref, set, get } from "firebase/database";
import {
  FaEdit,
  FaTrash,
  FaSave,
  FaPlus,
  FaSearch,
  FaClipboardList,
  FaEye,
  FaBook,
  FaUsers,
  FaChalkboardTeacher,
  FaListOl,
  FaQuestionCircle,
  FaStar,
  FaCheckCircle,
} from "react-icons/fa";
import AlertMessage from '../../AlertMessage';

const TeacherAndQuestionForm = () => {
  const [teacherData, setTeacherData] = useState({
    teacherName: "",
    class: "",
    division: "",
    subject: "",
    testName: "",
    showScore: "",
  });

  const [questionData, setQuestionData] = useState({
    question: "",
    options: ["", "", "", ""],
    correctAnswer: "",
    marks: "",
  });

  const [questions, setQuestions] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [showQuestionForm, setShowQuestionForm] = useState(false);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDivision, setSelectedDivision] = useState(" "); 
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classes, setClasses] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [classOptions, setClassOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const mobileNumber = localStorage.getItem('mobile')

   useEffect(() => {
        if (alertMessage) {
          setShowAlert(true);
          const timeoutId = setTimeout(() => {
            setShowAlert(false);
            setAlertMessage(""); 
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      }, [alertMessage]);
    
      useEffect(() => {
          const storedLanguage = localStorage.getItem('language') || 'English';
          setLanguage(storedLanguage);
        }, []);
      

      const sortClasses = (classes, language) => {
        const classOrder = {
          "Class I": 1,
          "Class II": 2,
          "Class III": 3,
          "Class IV": 4,
          "Class V": 5,
          "Class VI": 6,
          "Class VII": 7,
          "Class VIII": 8,
          "Class IX": 9,
          "Class X": 10,
          "Class XI": 11,
          "Class XII": 12,
          "इयत्ता पहिली": 1,
          "इयत्ता दुसरी": 2,
          "इयत्ता तिसरी": 3,
          "इयत्ता चौथी": 4,
          "इयत्ता पाचवी": 5,
          "इयत्ता सहावी": 6,
          "इयत्ता सातवी": 7,
          "इयत्ता आठवी": 8,
          "इयत्ता नववी": 9,
          "इयत्ता दहावी": 10,
          "इयत्ता अकरावी": 11,
          "इयत्ता बारावी": 12,
        };
      
        return classes.sort((a, b) => classOrder[a] - classOrder[b]);
      };
      
    

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };
  const fetchClassAndDivisionData = () => {
    const storedDivClasses = localStorage.getItem("classDiv");
    if (storedDivClasses) {
      const data = JSON.parse(storedDivClasses);
      const classList = [];
      const divisionList = {};
  
      for (const [className, divisions] of Object.entries(data)) {
        classList.push(className);
        divisionList[className] = Object.keys(divisions).filter(div => divisions[div]);
      }
  
      setClassOptions(classList);
      setDivisionOptions(divisionList);
    }
  };
  useEffect(() => {
    fetchClassAndDivisionData();
  }, []);

  useEffect(() => {
    const fetchTeacherName = async () => {
    
      const teacherRef = ref(db, `AttendanceData/${udiseNumber}/AttData`);
 
  
      const snapshot = await get(teacherRef);
      if (snapshot.exists()) {
        const teachersData = snapshot.val();
        const teacherList = [];

        Object.keys(teachersData).forEach((mobileNumber) => {
          const teacher = teachersData[mobileNumber];
          // Access fields exactly as they appear in Firebase
          if (teacher?.Name) {
            teacherList.push({
              name: teacher.Name,
              mobile: teacher.Mobno, // Match "Mobno" exactly as in Firebase
            });
          }
        });
        const teacherNames =  teacherList.map((t) => t.name)
  
        setTeacherData((prevData) => ({ ...prevData, teacherNames }));
      }
    };
    fetchTeacherName();
  }, []);

  
    const handleTeacherChange = (e) => {
      const { name, value } = e.target;
      setTeacherData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
    

  const handleQuestionChange = (e) => {
    const { name, value } = e.target;
    setQuestionData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOptionChange = (index, e) => {
    const { value } = e.target;
    const updatedOptions = [...questionData.options];
    updatedOptions[index] = value;
    setQuestionData((prevData) => ({
      ...prevData,
      options: updatedOptions,
    }));
  };

  const handleAddQuestion = () => {
    if (isEditing) {
      const updatedQuestions = [...questions];
      updatedQuestions[editIndex] = questionData;
      setQuestions(updatedQuestions);
      setIsEditing(false);
      setEditIndex(null);
    } else {
      setQuestions((prevQuestions) => [...prevQuestions, questionData]);
    }

    setQuestionData({
      question: "",
      options: ["", "", "", ""],
      correctAnswer: "",
      marks: "",
    });

    setShowTable(true);
  };

  const handleEditQuestion = (index) => {
    setIsEditing(true);
    setEditIndex(index);
    setQuestionData(questions[index]);
  };

  const handleDeleteQuestion = (index) => {
    const updatedQuestions = questions.filter((_, i) => i !== index);
    setQuestions(updatedQuestions);
    if (updatedQuestions.length === 0) {
      setShowTable(false);
    }
  };
  const handleClassChange = (event) => {
    const selected = event.target.value;
    setSelectedClass(selected);
  };


  const handleSubmitAllQuestions = async () => {
    // Calculate total marks
    const totalMarks = questions.reduce(
      (sum, question) => sum + parseInt(question.marks, 10),
      0
    );
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${teacherData.subject}/tests/${teacherData.testName}`;
    const data = {
      teacherName: teacherData.teacherName,
      questions,
      showScore: teacherData.showScore,
      totalmarks: totalMarks, // Add total marks to the data
    };

    try {
      const teacherRef = ref(db, path);
      await set(teacherRef, data);
      alert("All data stored successfully!");
      setTeacherData({
        teacherName: "",
        class: "",
        division: "",
        subject: "",
        testName: "",
        showScore: "",
      });
      setQuestions([]);
      setShowTable(false);
      setShowQuestionForm(false); // Hide the Question Form after submission
    } catch (error) {
      console.error("Error storing data:", error);
      alert("Failed to store data.");
    }
  };


  const handleFetchQuestions = async () => {
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${teacherData.subject}/tests/${teacherData.testName}`;;

    try {
      const teacherRef = ref(db, path);
      const snapshot = await get(teacherRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        setQuestions(data.questions || []);
        setShowTable(true);
        alert("Questions fetched successfully!");
      } else {
        alert("No data found for the provided details.");
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      alert("Failed to fetch questions.");
    }
  };

  return (
    <div className="main-content-of-page">
    <AlertMessage message={alertMessage} show={showAlert}/>
      <div>
        <h2
          style={{
            textAlign: "center",
            backgroundColor: "gray",
            color: "white",
            padding: "5px",
            borderRadius: "10px",
            marginBottom: "20px",
          }}
        >
        {language === "English" ? "Create Test" : "चाचणी तयार करा"}
        </h2>

        <div
          style={{
            height: "auto",
            backgroundColor: "#f0f0f0",
            width:'100%'
          }}
        >
          <form
            style={{
              background: "#ffffff",
              padding: "15px",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.4)",
              width: "600px",
              maxWidth: "90%", 
              margin:"auto",
              paddingTop:'20px'
            }}
          >
            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaChalkboardTeacher
                  style={{ marginRight: "10px", color: "#555" }}
                />
              <span> {language === "English" ? "Teacher Name" : "शिक्षकाचे नाव"}</span>
    </div>
    <select
      name="teacherName"
      value={teacherData.teacherName}
      onChange={(e) => setTeacherData((prevData) => ({ ...prevData, teacherName: e.target.value }))}
      required
      style={{
        width: "95%",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ddd",
        fontSize: "14px",
      }}
    >
      <option value="">{language === "English" ? "Select Teacher Name" : "शिक्षकाचे नाव निवडा"}</option>
      {teacherData.teacherNames && teacherData.teacherNames.map((name, index) => (
        <option key={index} value={name}>{name}</option>
      ))}
    </select>
  </label>

            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaUsers style={{ marginRight: "10px", color: "#555" }} />
                <span>{language === "English" ? "Class:" : "वर्ग"}</span>
              </div>
              
              <select
              id="currentClass"
              value={selectedClass}
              onChange={handleClassChange}
            >
              <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
              {classOptions.map((cls, index) => (
                <option key={index} value={cls}>{cls}</option>
              ))}
            </select>
            </label>

            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaUsers style={{ marginRight: "10px", color: "#555" }} />
                <span>{language === "English" ? "Division" : "तुकडी"}</span>
              </div>
              
              <select
              id="division"
              value={selectedDivision}
              onChange={handleDivisionChange}
            >
              <option value="">{language === "English" ? " Select Division: " : "तुकडी निवडा "}</option>
              {divisionOptions[selectedClass]?.map((division, index) => (
                <option key={index} value={division}>{division}</option>
              ))}
            </select>
            </label>

            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaBook style={{ marginRight: "10px", color: "#555" }} />
                <span>{language === "English" ? "Subject" : "विषय"}</span>
              </div>
              <input
                type="text"
                name="subject"
                placeholder="Enter subject"
                value={teacherData.subject}
                onChange={handleTeacherChange}
                required
                style={{
                  width: "95%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              />
            </label>

            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaClipboardList style={{ marginRight: "10px", color: "#555" }} />
                <span>{language === "English" ? "Test Name" : "चाचणी नाव"}</span>
              </div>
              <input
                type="text"
                name="testName"
                value={teacherData.testName}
                onChange={handleTeacherChange}
                placeholder="Enter test number"
                style={{
                  width: "95%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              />
            </label>

            <label style={{ display: "block", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FaEye style={{ marginRight: "10px", color: "#555" }} />
                <span>{language === "English" ? "Show Score to Student" : "विद्यार्थ्याला गुण दाखवा"}</span>
              </div>
              <select
                name="showScore"
                value={teacherData.showScore}
                onChange={handleTeacherChange}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                }}
              >
                <option value="">{language === "English" ? "Select" : "निवडा"}</option>
                <option value="Yes">{language === "English" ? "Yes" : "होय"}</option>
                <option value="No">{language === "English" ? "No" : "नाही"}</option>
              </select>
            </label>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                onClick={handleFetchQuestions}
                style={{
                  backgroundColor: "#008CBA",
                  color: "white",
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  width: "48%", // Ensures equal width
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#007B9E")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#008CBA")}
              >
                <FaSearch />
               {language === "English" ? " Previous Questions" : "मागील प्रश्न"}
              </button>

              <button
                type="button"
                onClick={() => setShowQuestionForm(true)}
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  width: "48%", // Ensures equal width
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
              >
                <FaPlus /> {language === "English" ? " Create Test " : "चाचणी तयार करा"}
              </button>
            </div>
          </form>
        </div>

        {/* Question Form (Conditionally Rendered) */}
        {showQuestionForm && (
          <>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f0f0f0", marginTop:'25px',paddingTop:'20px', overflow:'auto'
              }}
            >
            <h3
              style={{
              textAlign: "center",
                backgroundColor: "gray",
                color: "white",
                padding: "5px",
                borderRadius: "8px",
                margin:'auto',
                marginBottom: "18px",
                width:"300px"
              }}
            >
             {language === "English" ? "  Question Form " : "प्रश्न फॉर्म"}
            </h3>
              <form
                style={{
                  background: "#ffffff",
                  padding: "30px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  width: "75%",
                  maxWidth: "90%", margin:'auto'
                }}
              >
                {/* Question Field */}
                <label style={{ display: "block", marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <FaQuestionCircle
                      style={{ marginRight: "10px", color: "#555" }}
                    />
                    <span> {language === "English" ? "Question" : "प्रश्न"}</span>
                  </div>
                  <input
                    type="text"
                    name="question"
                    placeholder="Enter the question"
                    value={questionData.question}
                    onChange={handleQuestionChange}
                    required
                    style={{
                      width: "98%",
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </label>

                {/* Options Section */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <FaListOl style={{ marginRight: "10px", color: "#555" }} />
                    <h4 style={{ margin: 0 }}>{language === "English" ? "Options" : "पर्याय"}</h4>
                  </div>
                  {questionData.options.map((option, index) => (
                    <label
                      key={index}
                      style={{ display: "block", marginBottom: "10px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <span> {language === "English" ? "Option" : "पर्याय"}{index + 1}:</span>
                      </div>
                      <input
                        type="text"
                        value={option}
                        onChange={(e) => handleOptionChange(index, e)}
                        placeholder={`Option ${index + 1}`}
                        required
                        style={{
                          width: "98%",
                          padding: "10px",
                          borderRadius: "6px",
                          border: "1px solid #ddd",
                          fontSize: "14px",
                        }}
                      />
                    </label>
                  ))}
                </div>

                {/* Correct Answer Field */}
                <label style={{ display: "block", marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <FaCheckCircle
                      style={{ marginRight: "10px", color: "#555" }}
                    />
                    <span>{language === "English" ? "Correct Answer" : "बरोबर उत्तर"}</span>
                  </div>
                  <select
                    name="correctAnswer"
                    value={questionData.correctAnswer}
                    onChange={handleQuestionChange}
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <option value="" disabled>
                     {language === "English" ? " Select the correct answer" : "योग्य उत्तर निवडा"}
                    </option>
                    {questionData.options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </label>

                {/* Marks Field */}
                <label style={{ display: "block", marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <FaStar style={{ marginRight: "10px", color: "#555" }} />
                    <span>{language === "English" ? "Marks" : "गुण"}</span>
                  </div>
                  <input
                    type="number"
                    name="marks"
                    placeholder="Enter the marks"
                    value={questionData.marks}
                    onChange={(e) => {
                      handleQuestionChange(e);
                    }}
                    min="1"
                    max="5"
                    required
                    style={{
                      width: "98%",
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </label>

                {/* Submit Button */}
                <button
                  type="button"
                  onClick={handleAddQuestion}
                  style={{
                    backgroundColor: isEditing ? "#FFA500" : "#4CAF50",
                    color: "white",
                    padding: "8px 10px",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    width: "200px",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    margin:'auto',
                    marginTop: "20px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = isEditing
                      ? "#FF8C00"
                      : "#45a049")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = isEditing
                      ? "#FFA500"
                      : "#4CAF50")
                  }
                >
                  {isEditing ? <FaSave /> : <FaPlus />}
                  {isEditing ? "Update Question" : "Add Question"}
                </button>
              </form>
            </div>
          </>
        )}
        {showTable && (
          <div style={{ position:'relative' }}>
          <div
            style={{
              padding: "20px",
              backgroundColor: "#f0f0f0",
              margin:'auto',

            }}
          >
            <h3
              style={{
                textAlign: "center",
                backgroundColor: "gray",
                color: "white",
                padding: "5px",
                borderRadius: "8px",
                width: "300px",
                margin:'auto',
                gap: "10px",
              }}
            >
         {language === "English" ? " All Question" : "सर्व प्रश्न"}
            </h3>

            {/* Table */}
            <div
              style={{
                width: "100%",
                maxWidth: "1000px",
                overflowX: "auto",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px", margin:'auto',
                backgroundColor: "#ffffff", marginTop:'20px'
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse", margin:'20px auto'
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#6c757d",
                      color: "black",
                    }}
                  >
                    <th style={{ padding: "8px", textAlign: "left", fontWeight:'bold' }}>
                      {language === "English" ? "Question" : "प्रश्न"}
                    </th>
                    <th style={{ padding: "8px", textAlign: "left", fontWeight:'bold' }}>
                      {language === "English" ? "Options" : "पर्याय"}
                    </th>
                    <th style={{ padding: "8px", textAlign: "left", fontWeight:'bold' }}>
                      {language === "English" ? " Correct Option" : "योग्य पर्याय"}
                    </th>
                    <th style={{padding: "8px", textAlign: "left", fontWeight:'bold' }}>
                      {language === "English" ? " Marks" : "गुण"}
                    </th>
                    <th style={{padding: "8px", textAlign: "left", fontWeight:'bold' }}>
                     {language === "English" ? "  Action" : "कृती"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map((question, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom: "1px solid #ddd",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f9f9f9")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#ffffff")
                      }
                    >
                      <td style={{ padding: "10px", textAlign: "left" }}>
                        {question.question}
                      </td>
                      <td style={{ padding: "10px", textAlign: "left" }}>
                        {question.options.join(", ")}
                      </td>
                      <td style={{ padding: "10px", textAlign: "left" }}>
                        {question.correctAnswer}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center" }}>
                        {question.marks}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center" }}>
                        <button
                          onClick={() => handleEditQuestion(index)}
                          style={{
                            backgroundColor: "#FFA500",
                            color: "white",
                            padding: "5px 8px",
                            margin: "0 5px",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "12px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                            transition: "background-color 0.3s ease",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#e69500")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#FFA500")
                          }
                        >
                          <FaEdit /> Edit
                        </button>
                        <button
                          onClick={() => handleDeleteQuestion(index)}
                          style={{
                            backgroundColor: "#FF0000",
                            color: "white",
                            padding: "5px 8px ",
                            margin: "0 5px",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "12px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                            transition: "background-color 0.3s ease",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#cc0000")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#FF0000")
                          }
                        >
                          <FaTrash /> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button
            type="button"
            onClick={handleSubmitAllQuestions}
            style={{
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "7px 10px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer", margin:'10px auto 30px auto',
              width: "300px",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <FaCheckCircle />   {language === "English" ? "Submit All Questions" : "सर्व प्रश्न सबमिट करा"}
          </button>
          </div>


        )}

      </div>
    </div>
  );
};

export default TeacherAndQuestionForm;
